export const buildAuthStartUrl = (
    baseUrl: string,
    origin: string,
    platform: string,
    incomingSearch: string
) => {
    const outgoingSearchParams = new URLSearchParams({
        origin,
        platform
    });
    const incomingSearchParams = new URLSearchParams(incomingSearch);

    if (incomingSearchParams.has('msid')) {
        outgoingSearchParams.set('msid', incomingSearchParams.get('msid') ?? '');
    }

    const normalizedBaseUrl = `${baseUrl.replace(/\/+$/, '')}/`;
    const url = new URL('auth/start', normalizedBaseUrl);

    url.search = outgoingSearchParams.toString();

    return url.toString();
};